class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.setHeaderHeight();

        window.matchMedia('(max-width: 768px)').addEventListener('change', this.setHeaderHeight.bind(this));

        this.desktopMenu = document.querySelector('[data-mega-menu-desktop]');
        this.mobileMenu = document.querySelector('[data-mega-menu-mobile]');
        this.trigger = document.querySelector('[data-mobile-menu-trigger]');
        this.backdrop = document.querySelector('[data-menu-backdrop]');

        if (this.trigger) {
            this.trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation(); // evita che il click sul trigger chiuda subito il menu
                this.menu = this.getMenu();
                const wasOpen = this.menu.classList.contains('show');
                this.menu.classList.toggle('show');
                this.backdrop.classList.toggle('show');
                this.trigger.classList.toggle('open');
                if (wasOpen) {
                    this.resetMenuNavigation();
                }
                if (this.menu === this.mobileMenu) {
                    document.body.classList.toggle('tw-overflow-hidden', this.menu.classList.contains('show'));
                }
            });
        }

        // Chiude con ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeMenu();
            }
        });

        // Chiude cliccando fuori dal menu o dal trigger
        document.addEventListener('click', (e) => {
            this.menu = this.getMenu();
            const isClickInsideMenu = this.menu.contains(e.target);
            const isClickOnTrigger = this.trigger.contains(e.target);
            const isClickOnPopup = document.querySelector('[data-popup-mobile]');

            if (!isClickInsideMenu && !isClickOnTrigger && this.menu.classList.contains('show')) {
                this.closeMenu();
            }
            if (e.target == isClickOnPopup) {
                this.closeMenu();
            }
        });
    }

    getMenu() {
        if (window.innerWidth < 768) {
            return this.mobileMenu;
        } else {
            return this.desktopMenu;
        }
    }

    closeMenu() {
        if (!this.menu) this.menu = this.getMenu();
        this.menu.classList.remove('show');
        this.trigger.classList.remove('open');
        this.backdrop.classList.remove('show');
        document.body.classList.remove('tw-overflow-hidden');
        this.resetMenuNavigation();
    }

    resetMenuNavigation() {
        try {
            if (this.desktopMenu && typeof this.desktopMenu.resetNavigation === 'function') {
                this.desktopMenu.resetNavigation();
            }
        } catch(e) {}
        try {
            if (this.mobileMenu && typeof this.mobileMenu.resetNavigation === 'function') {
                this.mobileMenu.resetNavigation();
            }
        } catch(e) {}
    }

    setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
}

customElements.define('sticky-header', StickyHeader);


class AnnouncementBar extends HTMLElement {
    constructor() {
        super();

        this.heightPropertyName = "--sa-announceBar-height";
        this.setHeightVariable = this.setHeightVariable.bind(this);
    }

    connectedCallback() {
        this.setHeightVariable();
        window.addEventListener("resize", this.setHeightVariable);
    }

    disconnectedCallback() {
        window.removeEventListener("resize", this.setHeightVariable);
    }

    setHeightVariable() {
        const newHeight = `${this.offsetHeight}px`;
        document.documentElement.style.setProperty(this.heightPropertyName, newHeight);
    }
}
if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
}